<template>
  <div class="accordion">
    <AccordionSection
      v-for="(section, index) in accordionSections"
      :key="section.title"
      :index="index"
      :section="section" />
  </div>
</template>

<script>
import AccordionSection from './AccordionSection';

export default {
  name: 'PurchaseGiftAccordion',
  components: {
    AccordionSection,
  },
  data() {
    return {};
  },
  computed: {
    accordionSections() {
      return this.$store.getters.accordionSections;
    },
  },
  methods: {
  },
};
</script>


<style lang="scss" scoped>
@import '../../../assets/scss/variables.scss';

.accordion {
  width: 100%;
  margin-bottom: 58px;
}

</style>
